import Header from 'components/headers/bulletins'
import PaymentIcon from 'assets/images/buySubscription/payment-selected.svg'
import useSetCommission from './hooks/useSetCommission'
import { useParams } from 'react-router-dom'
import { toggleSupportModal } from 'store/redux/sidebar'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store/redux'
import SupportModal from 'components/modals/supportModal'
export default function Commission() {
    const { moneyPool } = useParams()
    const { mutate } = useSetCommission()
    const dispatch = useDispatch()
    const { isOpenSupportModal } = useSelector(
        (state: RootState) => state.sideBarControler
    )
    return (
        <>
            <div className="flex flex-col bg-[#F2F2F2] h-screen">
                <div className=" grow-0">
                    <Header title={`ارتقاء صندوق`} />
                </div>
                <div className=" grow px-2">
                    <p className=" my-3 text-center">
                        نسخه‌ی انتخابی شما برای ارتقای صندوق پس‌انداز
                    </p>
                    <div className=" bg-plan-bg border-1 border-green-1 rounded-lg p-4">
                        <div className="flex">
                            <img src={PaymentIcon} alt="payment" />
                            <p className=" mx-2">نسخه‌ی کارمزدی</p>
                        </div>
                        <div className=" flex justify-between items-center mt-3">
                            <p className=" text-xs">
                                کارمزد به ازای هر تراکنش اعضا بسته به مبلغ
                                تراکنش :{' '}
                            </p>
                            <p className=" text-sm w-full text-left">
                                ۵,۰۰۰ تا ۳۰,۰۰۰ تومان
                            </p>
                        </div>
                    </div>
                    <div className=" bg-white rounded-lg p-3 my-3">
                        <p>مبلغ کارمزد به ازای هر تراکنش‌:</p>
                        <ul className=" px-4 mt-3">
                            <li className=" text-sm list-disc my-1">
                                با انتخاب این روش، ۲% از مبلغ هر تراکنش،‌ به
                                دلیل محاسبه کارمزد (حداقل۵۰۰۰ تومان و
                                حداکثر۳۰,۰۰۰ تومان)،‌ به مبلغ تراکنش‌ افزوده
                                خواهد شد.
                            </li>
                            <li className=" text-sm list-disc">
                                کارمزد پرداختی در این روش شامل تمامی هزینه‌های
                                درگاه پرداخت،‌ پیامک، پشتیبانی از اطلاعات صندوق
                                و ... می شود.{' '}
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="grow-0 mx-2">
                    <div className=" my-1 text-center">
                        <p>نیاز به راهنمایی دارید؟</p>
                        <p
                            className=" text-[#808080] underline-offset-8"
                            onClick={() =>
                                dispatch(
                                    toggleSupportModal({
                                        isOpenSupportModal: true,
                                    })
                                )
                            }
                        >
                            با مشاور همیان تماس بگیرید
                        </p>
                    </div>
                    <button
                        className=" w-full rounded-lg bg-green-1 text-white py-3 mt-4 mb-2"
                        onClick={() => mutate(Number(moneyPool))}
                    >
                        تایید
                    </button>
                </div>
            </div>
            <SupportModal
                show={isOpenSupportModal}
                onHide={() =>
                    dispatch(toggleSupportModal({ isOpenSupportModal: false }))
                }
            />
        </>
    )
}
